import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "list-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "filter-box" }
const _hoisted_4 = { class: "filter-box" }
const _hoisted_5 = { class: "filter-box" }
const _hoisted_6 = { class: "filter-box" }
const _hoisted_7 = { class: "filter-box" }
const _hoisted_8 = { class: "filter-box" }
const _hoisted_9 = { class: "filter-box" }
const _hoisted_10 = { class: "filter-box" }
const _hoisted_11 = { class: "filter-box" }
const _hoisted_12 = { class: "filter-box" }
const _hoisted_13 = { class: "filter-box" }
const _hoisted_14 = { class: "filter-box" }
const _hoisted_15 = { class: "filter-box" }
const _hoisted_16 = { class: "filter-box" }
const _hoisted_17 = { class: "filter-box" }
const _hoisted_18 = { class: "filter-box" }
const _hoisted_19 = { class: "filter-box" }
const _hoisted_20 = { class: "filter-box" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "clearfix tab-title btn-container mt-10" }
const _hoisted_23 = { class: "tab-title_left fl" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "underlineForm" }
const _hoisted_26 = { class: "dialog-footer" }
const _hoisted_27 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_TableList = _resolveComponent("TableList")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_LogisticTable = _resolveComponent("LogisticTable")!
  const _component_grid_item = _resolveComponent("grid-item")!
  const _component_grid_layout = _resolveComponent("grid-layout")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_MiniBusinessList = _resolveComponent("MiniBusinessList")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_waves = _resolveDirective("waves")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.isFilterCollapse)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_3, [
                _cache[33] || (_cache[33] = _createElementVNode("span", { class: "label" }, "采购编号", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.no,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listQuery.no) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _cache[34] || (_cache[34] = _createElementVNode("span", { class: "label" }, "发票号码", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.invoiceNo,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listQuery.invoiceNo) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _cache[35] || (_cache[35] = _createElementVNode("span", { class: "label" }, "发票代码", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.invoiceCode,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.listQuery.invoiceCode) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[36] || (_cache[36] = _createElementVNode("span", { class: "label" }, "供应商", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.supplier,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.listQuery.supplier) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[37] || (_cache[37] = _createElementVNode("span", { class: "label" }, "开票状态", -1)),
                _createVNode(_component_el_select, {
                  filterable: true,
                  modelValue: _ctx.listQuery.invoiceStatus,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.listQuery.invoiceStatus) = $event)),
                  class: "filter-item",
                  placeholder: "",
                  clearable: "",
                  size: _ctx.t('table.btnSize'),
                  onChange: _ctx.handleFilter
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoiceStatusOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.mark,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "size", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[38] || (_cache[38] = _createElementVNode("span", { class: "label" }, "付款状态", -1)),
                _createVNode(_component_el_select, {
                  filterable: true,
                  modelValue: _ctx.listQuery.paymentStatus,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.listQuery.paymentStatus) = $event)),
                  class: "filter-item",
                  placeholder: "",
                  clearable: "",
                  size: _ctx.t('table.btnSize'),
                  onChange: _ctx.handleFilter
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentStatusOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.mark,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "size", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[39] || (_cache[39] = _createElementVNode("span", { class: "label" }, "入库状态", -1)),
                _createVNode(_component_el_select, {
                  filterable: true,
                  modelValue: _ctx.listQuery.storageStatus,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.listQuery.storageStatus) = $event)),
                  class: "filter-item",
                  placeholder: "",
                  clearable: "",
                  size: _ctx.t('table.btnSize'),
                  onChange: _ctx.handleFilter
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storageStatusOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.mark,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "size", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[40] || (_cache[40] = _createElementVNode("span", { class: "label" }, "材料编号", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.materialNo,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.listQuery.materialNo) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[41] || (_cache[41] = _createElementVNode("span", { class: "label" }, "材料品牌", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.materialBrand,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.listQuery.materialBrand) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[42] || (_cache[42] = _createElementVNode("span", { class: "label" }, "材料名称", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.materialName,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.listQuery.materialName) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[43] || (_cache[43] = _createElementVNode("span", { class: "label" }, "材料型号", -1)),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.listQuery.materialModel,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.listQuery.materialModel) = $event)),
                  style: {"width":"200px"},
                  size: _ctx.t('table.btnSize'),
                  class: "filter-item",
                  clearable: "",
                  onKeyup: _withKeys(_ctx.handleFilter, ["enter"])
                }, null, 8, ["modelValue", "size", "onKeyup"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _cache[44] || (_cache[44] = _createElementVNode("span", { class: "label" }, "登记时间", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.startTime,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.listQuery.startTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[45] || (_cache[45] = _createElementVNode("span", { class: "label" }, "到", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.endTime,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.listQuery.endTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _cache[46] || (_cache[46] = _createElementVNode("span", { class: "label" }, "开票时间", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.invoiceStartTime,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.listQuery.invoiceStartTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[47] || (_cache[47] = _createElementVNode("span", { class: "label" }, "到", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.invoiceEndTime,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.listQuery.invoiceEndTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _cache[48] || (_cache[48] = _createElementVNode("span", { class: "label" }, "付款时间", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.payStartTime,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.listQuery.payStartTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _cache[49] || (_cache[49] = _createElementVNode("span", { class: "label" }, "到", -1)),
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.listQuery.payEndTime,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.listQuery.payEndTime) = $event)),
                  type: "date",
                  placeholder: " ",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  onChange: _ctx.handleFilter,
                  size: _ctx.t('table.btnSize')
                }, null, 8, ["modelValue", "onChange", "size"])
              ])
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_20, [
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleFilter
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('table.search')), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handleCommand('batchDengji')))
          }, {
            default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
              _createTextVNode(" 批量发票登记 ", -1)
            ]))]),
            _: 1
          }, 8, ["size"])), [
            [_directive_waves],
            [_directive_permission, { pkey: `${_ctx.permissionName}_DJ` }]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            type: "primary",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.handleCommand('add')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('table.add')), 1)
            ]),
            _: 1
          }, 8, ["size"])), [
            [_directive_permission, { pkey: `${_ctx.permissionName}_ADD` }]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _ctx.handleReset
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('table.reset')), 1)
            ]),
            _: 1
          }, 8, ["size", "onClick"])), [
            [_directive_waves]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "filter-item",
            size: _ctx.t('table.btnSize'),
            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.isFilterCollapse = !_ctx.isFilterCollapse))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isFilterCollapse ? '展开' : '收起'), 1)
            ]),
            _: 1
          }, 8, ["size"])), [
            [_directive_waves]
          ]),
          _createElementVNode("span", {
            class: "svg-icon cursor mr-10 ml-10",
            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.handleCommand('refresh')))
          }, [...(_cache[51] || (_cache[51] = [
            _createElementVNode("i", { class: "icon-tubiao-27 iconfont" }, null, -1)
          ]))]),
          _createElementVNode("span", {
            class: "svg-icon cursor",
            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.handleCommand('column')))
          }, [...(_cache[52] || (_cache[52] = [
            _createElementVNode("i", { class: "icon-tubiao-28 iconfont" }, null, -1)
          ]))]),
          _cache[53] || (_cache[53] = _createElementVNode("span", { class: "ml-10 filter-mark" }, [
            _createElementVNode("span", { class: "status-item" }, [
              _createElementVNode("span", {
                class: "status-square",
                style: {"background-color":"red"}
              }),
              _createElementVNode("span", { class: "status-text" }, "待开票、部分开票")
            ])
          ], -1))
        ])
      ]),
      _createVNode(_component_grid_layout, {
        layout: _ctx.layouts,
        "onUpdate:layout": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.layouts) = $event)),
        "col-num": 12,
        "row-height": _ctx.rowHeight,
        "is-draggable": false,
        "is-resizable": true,
        "is-mirrored": false,
        "vertical-compact": true,
        margin: [10, 10],
        "use-css-transforms": false
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layouts, (item, index) => {
            return (_openBlock(), _createBlock(_component_grid_item, {
              x: item.x,
              y: item.y,
              w: item.w,
              h: item.h,
              i: item.i,
              key: item.i,
              minW: item.minW,
              maxW: item.maxW,
              minH: item.minH,
              static: item.static,
              onResize: _ctx.handleResizedEvent,
              onResized: _ctx.handleResizedEvent
            }, {
              default: _withCtx(() => [
                (index === 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _withDirectives((_openBlock(), _createBlock(_component_TableList, {
                        ref_for: true,
                        ref: rf => { if (rf) _ctx.tableDataRef[index] = rf },
                        dataList: _ctx.list,
                        total: _ctx.total,
                        columnAllData: _ctx.columnAllData,
                        tableName: _ctx.TableName,
                        permissionName: _ctx.permissionName,
                        showSelection: true,
                        isShowPagination: false,
                        handleDefaultWidth: 220,
                        highlightCurrentRow: true,
                        layoutHeight: true,
                        newHpx: _ctx.newHpx,
                        style: {"height":"calc(100% )","overflow":"hidden"},
                        tableRowClassName: _ctx.tableRowClassName,
                        showSummary: true,
                        onRowClick: _ctx.handleRowClick,
                        onCommandChange: _ctx.handleCommand
                      }, {
                        "operation-action": _withCtx((scope) => [
                          _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                            href: "javascript:void(0);",
                            class: "mr-10",
                            type: "primary",
                            onClick: ($event: any) => (_ctx.handleCommand('dengji', scope.row))
                          }, {
                            default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                              _createTextVNode(" 发票登记 ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"])), [
                            [_directive_permission, { pkey: `${_ctx.permissionName}_DJ` }]
                          ]),
                          _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                            href: "javascript:void(0);",
                            class: "mr-10",
                            type: "primary",
                            onClick: ($event: any) => (_ctx.handleCommand('fplist', scope.row))
                          }, {
                            default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                              _createTextVNode(" 发票明细 ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"])), [
                            [_directive_permission, { pkey: `${_ctx.permissionName}_LIST` }]
                          ])
                        ]),
                        _: 1
                      }, 8, ["dataList", "total", "columnAllData", "tableName", "permissionName", "newHpx", "tableRowClassName", "onRowClick", "onCommandChange"])), [
                        [_directive_loading, _ctx.listLoading]
                      ]),
                      _withDirectives(_createVNode(_component_el_pagination, {
                        class: "mt-20",
                        total: _ctx.total,
                        currentPage: _ctx.listQuery.page,
                        "onUpdate:currentPage": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.listQuery.page) = $event)),
                        "page-size": _ctx.listQuery.size,
                        "page-sizes": _ctx.pageSizes,
                        onSizeChange: _ctx.handleSizeChange,
                        onCurrentChange: _ctx.handleCurrentChange,
                        layout: "total, sizes, prev, pager, next"
                      }, null, 8, ["total", "currentPage", "page-size", "page-sizes", "onSizeChange", "onCurrentChange"]), [
                        [_vShow, _ctx.total > 0]
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (index === 1)
                  ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("ul", _hoisted_23, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabList, (item) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: item.id,
                              class: _normalizeClass({ active: _ctx.activeTab === item.id }),
                              onClick: ($event: any) => (_ctx.handleTabClick(item))
                            }, _toDisplayString(item.name), 11, _hoisted_24))
                          }), 128))
                        ])
                      ]),
                      (_ctx.activeTab === 1)
                        ? (_openBlock(), _createBlock(_component_LogisticTable, {
                            key: 0,
                            sendFlag: 0,
                            TableName: "TABLE_DELIVERY_INFO",
                            permissionName: "LOGISTIC_INFO",
                            ref_for: true,
                            ref: "LogisticTable",
                            sourceId: _ctx.activeId,
                            sourceType: 6
                          }, null, 8, ["sourceId"]))
                        : _createCommentVNode("", true)
                    ], 512)), [
                      [_vShow, !_ctx.isSubMenuCollapse]
                    ])
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["x", "y", "w", "h", "i", "minW", "maxW", "minH", "static", "onResize", "onResized"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["layout", "row-height"])
    ], 512), [
      [_vShow, !_ctx.dialogFormVisible]
    ]),
    (_ctx.dengjiVisible)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: _ctx.dengjiVisible,
          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.dengjiVisible) = $event)),
          width: "1000px",
          title: ""
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_26, [
              _createVNode(_component_el_button, {
                onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.dengjiVisible = false)),
                type: "danger"
              }, {
                default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                  _createTextVNode("取消", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.handleDJ
              }, {
                default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                  _createTextVNode("确定", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _cache[58] || (_cache[58] = _createElementVNode("div", { class: "form-title mb-10" }, [
              _createElementVNode("span", { class: "label blue" }, "采"),
              _createElementVNode("span", { class: "left" }, "采购信息")
            ], -1)),
            _createVNode(_component_MiniBusinessList, {
              businessList: _ctx.selectionArray,
              ref: "miniBusinessList",
              isRateVisible: false
            }, {
              before: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "no",
                  label: "采购编号",
                  "show-overflow-tooltip": "",
                  width: "120"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "supplier",
                  label: "采购商",
                  "show-overflow-tooltip": "",
                  width: "120"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.supplier.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "total",
                  label: "总费用",
                  "show-overflow-tooltip": "",
                  align: "right",
                  "min-width": "100"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(_ctx.$currency(row.total)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "invoiceAmount",
                  label: "已开票费用",
                  "show-overflow-tooltip": "",
                  align: "right",
                  "min-width": "100"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(_ctx.$currency(row.invoiceAmount ?? 0)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "amountFee",
                  label: "发票金额",
                  align: "right",
                  "min-width": "180"
                }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_el_input_number, {
                      modelValue: row.amountFee,
                      "onUpdate:modelValue": ($event: any) => ((row.amountFee) = $event),
                      precision: 2,
                      max: _ctx.ruleForm.amountFee,
                      "controls-position": "right"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "max"])
                  ]),
                  _: 1
                })
              ]),
              after: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "containsRate",
                  label: "是否含税",
                  "min-width": "100"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.containsRate ? '是' : '否'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "rate",
                  label: "税率",
                  "min-width": "100"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.rate || 0) + "% ", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "invoiceType",
                  label: "发票类型",
                  width: "100",
                  "show-overflow-tooltip": ""
                })
              ]),
              _: 1
            }, 8, ["businessList"]),
            _cache[59] || (_cache[59] = _createElementVNode("div", { class: "form-title mt-30 mb-10" }, [
              _createElementVNode("span", { class: "label green" }, "登"),
              _createElementVNode("span", { class: "left" }, "登记发票")
            ], -1)),
            _createVNode(_component_el_form, {
              ref: "dataForm",
              model: _ctx.ruleForm,
              rules: _ctx.rules,
              "label-position": "top",
              "label-width": "100px",
              class: "mb-20"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "扫码抢",
                  prop: "invoiceNumber"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.ruleForm.invoiceNumber,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.ruleForm.invoiceNumber) = $event)),
                      type: "textarea",
                      class: "filter-item",
                      onKeyup: _withKeys(_ctx.handleBarCodeChange, ["enter"]),
                      style: {"width":"700px"}
                    }, null, 8, ["modelValue", "onKeyup"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_el_form_item, {
                    label: "发票号码",
                    prop: "no"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ruleForm.no,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.ruleForm.no) = $event)),
                        type: "input",
                        class: "filter-item",
                        placeholder: " "
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "发票代码",
                    prop: "code"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ruleForm.code,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.ruleForm.code) = $event)),
                        type: "input",
                        class: "filter-item",
                        placeholder: " "
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "发票校验码",
                    prop: "checkCode"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ruleForm.checkCode,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.ruleForm.checkCode) = $event)),
                        type: "input",
                        class: "filter-item",
                        placeholder: " "
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "开票日期",
                    prop: "date"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.ruleForm.date,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.ruleForm.date) = $event)),
                        type: "date",
                        placeholder: " ",
                        format: "YYYY-MM-DD",
                        "value-format": "YYYY-MM-DD"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.fpListVisible)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 1,
          modelValue: _ctx.fpListVisible,
          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.fpListVisible) = $event)),
          width: "1000px",
          title: ""
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_27, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.fpListVisible = false))
              }, {
                default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                  _createTextVNode("关闭", -1)
                ]))]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_MiniBusinessList, {
              businessList: _ctx.fpList,
              ref: "miniBusinessList",
              isRateVisible: false
            }, {
              before: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "invoiceNo",
                  label: "发票号码",
                  "show-overflow-tooltip": "",
                  width: "120"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "invoiceCode",
                  label: "发票代码",
                  "show-overflow-tooltip": "",
                  width: "120"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "invoiceCheckCode",
                  label: "发票检查码",
                  "show-overflow-tooltip": "",
                  width: "120"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "invoiceAmount",
                  label: "发票金额",
                  "show-overflow-tooltip": "",
                  align: "right",
                  "min-width": "100"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(_ctx.$currency(row.invoiceAmount)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "invoiceTypeValue",
                  label: "发票类型",
                  "show-overflow-tooltip": "",
                  width: "120"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "invoiceDate",
                  label: "开票日期",
                  "show-overflow-tooltip": "",
                  width: "120"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "rate",
                  label: "税率",
                  "min-width": "80"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.rate || 0) + "% ", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "createTime",
                  label: "登记时间",
                  "show-overflow-tooltip": "",
                  width: "180"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "createUserName",
                  label: "登记人",
                  "show-overflow-tooltip": "",
                  width: "120"
                })
              ]),
              _: 1
            }, 8, ["businessList"])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ]))
}